import { StanButton } from '@/components/core-components/StanButton/StanButton';
import IconInfoCircle from '@/assets/icons/ic-info-circle.svg';
import IconProductCollectEmails from '@/assets/icons/ic-product-collect-emails.svg';

export default function GetHelpPage() {
    return (
        <div className='bg-canvas flex min-h-svh items-center justify-center px-4'>
            <div className='flex max-w-xl flex-col items-center'>
                <h2 className='max-w-ask-stanley-xl mb-8 text-center'>
                    We&apos;re here to help! Email us or visit our Help Center
                </h2>
                <div className='flex flex-col flex-wrap justify-center gap-4 sm:flex-row'>
                    <StanButton
                        icon={IconInfoCircle}
                        name='visit-help-center'
                        color='secondary'
                        onClick={() => {
                            window.open('https://help.stan.store', '_blank');
                        }}
                    >
                        Visit Help Center
                    </StanButton>
                    <StanButton
                        icon={IconProductCollectEmails}
                        name='email-us'
                        color='secondary'
                        onClick={() => {
                            window.location.href = 'mailto:friends@stanwith.me';
                        }}
                    >
                        Email Us
                    </StanButton>
                </div>
            </div>
        </div>
    );
}
